if (!customElements.get('shipping-bar')) {
  customElements.define('shipping-bar',
    class ShippingBar extends HTMLElement {
  static get observedAttributes() { return ['data-cart-totals']; }
  constructor() { super(); this.threshold = 0; this.cartTotals = 0; }
  connectedCallback() { this.setString(); this.setBar(); }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-cart-totals' && oldValue !== newValue) { this.setString(); this.setBar(); }
  }
  getTiers() {
    return [...this.querySelectorAll('.cart-slide__label')]
      .map(function (el) {
        return {
          el: el,
          price: parseFloat(el.dataset.price),
          type: el.dataset.type || 'discount',
          code: (el.dataset.code || '').trim(),
          label: (el.querySelector('p') ? el.querySelector('p').textContent : '').trim()
        };
      })
      .filter(function (t) { return !isNaN(t.price) && t.price > 0; })
      .sort(function (a, b) { return a.price - b.price; });
  }
  setString() {
    var cartTotals = parseFloat(this.dataset.cartTotals) / 100;
    if (isNaN(cartTotals)) return;
    var tiers = this.getTiers();
    if (!tiers.length) return;
    var cartContext = this.closest('cart-slide') || this.closest('.main-cart');
    var textContainer = cartContext ? cartContext.querySelector('[data-shipping-bar-text]') : document.querySelector('[data-shipping-bar-text]');
    var wrapper = this.closest('.shipping-bar-wrapper');
    var moneyFormat = this.dataset.moneyFormat || window.money_format;
    var next = tiers.find(function (t) { return t.price > cartTotals; });
    if (textContainer) {
      if (next) {
        this.classList.remove('shipping-unlocked');
        if (wrapper) wrapper.classList.remove('shipping-unlocked');
        var remaining = (next.price - cartTotals) * 100;
        var intro = this.dataset.introText || 'Add ||amount|| more to unlock ||reward||';
        var msg;
        if (intro.indexOf('||amount||') !== -1) {
          msg = intro.replace(/\|\|amount\|\|/g, Shopify.formatMoney(remaining, moneyFormat)).replace(/\|\|reward\|\|/g, next.label);
        } else {
          msg = 'Add ' + Shopify.formatMoney(remaining, moneyFormat) + ' more to unlock ' + next.label;
        }
        textContainer.innerHTML = msg;
        textContainer.style.fontWeight = '400';
      } else {
        this.classList.add('shipping-unlocked');
        if (wrapper) wrapper.classList.add('shipping-unlocked');
        textContainer.innerHTML = this.dataset.allUnlockedMessage || 'You have unlocked all rewards!';
        textContainer.style.fontWeight = '700';
      }
    }
    this.threshold = tiers[tiers.length - 1].price;
    this.cartTotals = cartTotals;
    this.evaluateTiers(cartTotals, tiers);
  }
  evaluateTiers(cartTotals, tiers) {
    tiers = tiers || this.getTiers();
    tiers.forEach(function (t) { t.el.classList.toggle('tier-unlocked', cartTotals >= t.price); });
    var unlockedCodes = tiers.filter(function (t) { return cartTotals >= t.price && t.type === 'discount' && t.code; }).map(function (t) { return t.code; });
    this.dataset.unlockedCodes = JSON.stringify(unlockedCodes);
    try {
      var cs = this.closest('cart-slide');
      if (cs && typeof cs.applyTierDiscounts === 'function') { cs.applyTierDiscounts(unlockedCodes); }
    } catch (e) {}
  }
  setBar() {
    var element = this.querySelector('[data-progress-span]');
    if (!element) return;
    var tiers = this.getTiers();
    if (!tiers.length) return;
    var pos = this.evenPositions(tiers.length);
    var total = parseFloat(this.dataset.cartTotals) / 100 || 0;
    var last = tiers[tiers.length - 1].price;
    var fill;
    if (total >= last) {
      fill = 100;
    } else {
      var prevPrice = 0, prevPos = 0;
      fill = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (total < tiers[i].price) {
          fill = prevPos + ((total - prevPrice) / (tiers[i].price - prevPrice)) * (pos[i] - prevPos);
          break;
        }
        prevPrice = tiers[i].price;
        prevPos = pos[i];
      }
    }
    fill = Math.max(0, Math.min(100, fill));
    element.setAttribute('data-value', fill.toFixed(2));
    element.style.setProperty('--bar-width', fill.toFixed(2) + '%');
    element.innerText = fill.toFixed(2);
    this.threshold = last;
    this.positionIcons();
  }
  evenPositions(n) {
    var L = 15, R = 85;
    if (n <= 1) return [R];
    var arr = [];
    for (var i = 0; i < n; i++) arr.push(L + ((R - L) * i) / (n - 1));
    return arr;
  }
  positionIcons() {
    var tiers = this.getTiers();
    if (!tiers.length) return;
    var pos = this.evenPositions(tiers.length);
    tiers.forEach(function (t, i) {
      var el = t.el;
      el.style.position = 'absolute';
      el.style.left = pos[i] + '%';
      el.style.top = '0px';
      el.style.transform = 'translateX(-50%)';
    });
  }
  updateCartTotals(cartTotalPrice) {
    if (cartTotalPrice === undefined || cartTotalPrice === null) return;
    this.dataset.cartTotals = cartTotalPrice;
    this.setString();
    this.setBar();
  }
}
  );
}